import { createRoot } from "react-dom/client";
import "@wordpress/components/build-style/style.css";
import "@wordpress/dataviews/build-style/style.css";
import "react-responsive-modal/styles.css";

import "./style.scss";
import "./yup";
import App from "./app";

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
}
